export enum JobType {
    FULL_TIME = "Full Time",
    PART_TIME = "Part Time",
    CONTRACT_BASED = "Contract Based",
    INTERNSHIP = "Internship",
    FREELANCE = "Freelance"
  }
  